export default __webpack_public_path__ + "static/media/runRightLight.9c2d011c.svg";